import { isMac } from '../../../../../../utils/misc';

/**
 * 音频播放器快捷键
 */

/** 上一句快捷键key值 */
const PLAYER_PREV_HOT_KEY = isMac ? 'cmd+left' : 'ctrl+left';
/** 下一句快捷键key值 */
const PLAYER_NEXT_HOT_KEY = isMac ? 'cmd+right' : 'ctrl+right';
/** 切换播放态 */
const PLAYER_TOGGLE_PLAY_HOT_KEY = isMac
  ? 'alt+space,space'
  : 'shift+space,space';

export { PLAYER_PREV_HOT_KEY, PLAYER_NEXT_HOT_KEY, PLAYER_TOGGLE_PLAY_HOT_KEY };
